/**
 * Visible header search affordance that opens the command palette (issue #1440).
 *
 * On desktop it renders a search box-styled button showing the Cmd/Ctrl-K hint;
 * on mobile it collapses to a single >=44px icon button.
 */
import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { useGlobalSearch } from "./globalSearchContext";

export function HeaderSearchButton() {
  const { open } = useGlobalSearch();
  const [isMac, setIsMac] = useState(true);

  useEffect(() => {
    // Show the right modifier glyph for the platform.
    setIsMac(/Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent));
  }, []);

  return (
    <>
      {/* Mobile: icon-only button */}
      <button
        type="button"
        data-tour="header-search"
        onClick={open}
        aria-label="Open search"
        className="sm:hidden min-h-[44px] min-w-[44px] p-2.5 rounded-lg hover:bg-[var(--color-bg-page)] transition-colors flex items-center justify-center"
      >
        <Search className="h-5 w-5 text-[var(--color-text-secondary)]" />
      </button>

      {/* Desktop: search-box-styled button with shortcut hint */}
      <button
        type="button"
        data-tour="header-search"
        onClick={open}
        aria-label="Open search"
        className="hidden sm:flex items-center gap-2 min-h-[40px] rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-page)] px-3 text-sm text-[var(--color-text-muted)] hover:border-[var(--color-text-muted)] transition-colors w-44 lg:w-56"
      >
        <Search className="h-4 w-4 shrink-0" />
        <span className="flex-1 text-left">Search...</span>
        <kbd className="rounded border border-[var(--color-border)] px-1.5 py-0.5 text-xs font-sans">
          {isMac ? "⌘" : "Ctrl"} K
        </kbd>
      </button>
    </>
  );
}
